module.exports = "<span data-bind=\"{html: html}\"></span>\r\n\r\n\r\n";